import React from "react";
import { IonCheckbox, IonLabel } from "@ionic/react";
import { Controller, FieldError } from "react-hook-form";
import { IControlData } from "../../models/Control";
import classNames from "classnames";
import InputError from "../utils/InputError";
import InputHint from "../utils/InputHint";
import "./CheckboxWrapper.scss";

interface IProps {
  name: string;
  label: string | null;
  error?: FieldError;
  hint?: string;
  controlData?: IControlData;
}

const CheckboxWrapper: React.FC<IProps> = ({ name, error, label, controlData, hint }) => {
  return (
    <div>
      <div
        className={classNames("ion-stack", "checkbox-wrapper", {
          error: error,
        })}
      >
        {controlData ? (
          <Controller
            name={name}
            render={({ field: { onChange, value } }) => (
              <>
                <IonCheckbox checked={value} onIonChange={(e) => onChange(e.detail.checked)} name={name} style={{ minWidth: 26 }} />
                {label && (
                  <IonLabel className="clickable" onClick={() => onChange(!value)}>
                    {label}
                  </IonLabel>
                )}
              </>
            )}
            {...controlData}
          />
        ) : null}
      </div>
      {error ? <InputError>{error.message ?? ""}</InputError> : null}
      {hint ? <InputHint>{hint}</InputHint> : null}
    </div>
  );
};

export default CheckboxWrapper;
